import React from 'react';
import { socialHandle, socialLinks } from '../../data/socialLinks';
import type { SocialLink } from '../../data/socialLinks';
export function FollowUs() {
  return <section className="border-t border-ink/10 px-6 py-16" aria-labelledby="follow-heading" data-id="element-64" data-mp="3ukz60hs4ij11">
      <div className="mx-auto max-w-2xl text-center" data-id="element-65" data-mp="3b0ejvcytbz7">
        <h2 id="follow-heading" className="font-display text-3xl text-ink" data-id="element-66" data-mp="86pieaw0pf1b">
          Follow the <em className="text-gold" data-id="element-67" data-mp="36q67jyia0oqs">love</em>
        </h2>
        <p className="mx-auto mt-2 max-w-md font-body text-[15px] leading-relaxed text-ink/70" data-id="element-68" data-mp="36rr05il15xm0">
          See more real weddings, behind-the-scenes moments, and the mountain views your guests
          will never forget.
        </p>
        <ul className="mt-8 flex flex-wrap items-center justify-center gap-3" data-id="element-69" data-mp="3ln6pjaao15c2">
          {socialLinks.map(link => <li key={link.name} data-id="element-70" data-mp="vwa594vakwfv">
              <a href={link.href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2.5 whitespace-nowrap rounded-full border border-ink/15 px-6 py-3 font-sans text-sm text-ink transition-colors duration-150 hover:border-logo hover:text-logo focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-logo" data-id="element-71" data-mp="vzfq27ww1c5s">
                <SocialIcon name={link.name} data-id="element-72" data-mp="2al8qxeiybzsf" />
                {link.name}
              </a>
            </li>)}
        </ul>
        <p className="mt-6 font-sans text-[11px] font-medium uppercase tracking-[0.25em] text-ink/50" data-id="element-73" data-mp="25oid6xumdga6">
          {socialHandle}
        </p>
      </div>
    </section>;
}
function SocialIcon({
  name
}: {
  name: SocialLink['name'];
}) {
  const common = {
    className: 'h-4 w-4',
    'aria-hidden': true,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const
  };
  if (name === 'Instagram') {
    return <svg {...common} data-id="element-74" data-mp="18a0j4x5nh9ty">
        <rect x="3" y="3" width="18" height="18" rx="5" data-id="element-75" data-mp="189hbqadmm3u6" />
        <circle cx="12" cy="12" r="4" data-id="element-76" data-mp="18c3l8fk2utf1" />
        <circle cx="17.5" cy="6.5" r="0.6" fill="currentColor" data-id="element-77" data-mp="1d9mypd8yb25x" />
      </svg>;
  }
  if (name === 'Facebook') {
    return <svg {...common} data-id="element-78" data-mp="yd4ifdlztrzy">
        <path d="M15 3h-2.5A3.5 3.5 0 0 0 9 6.5V9H6.5v3.5H9V21h3.5v-8.5H15l.5-3.5h-3V7a1 1 0 0 1 1-1H15z" data-id="element-79" data-mp="ydxixwuczl9n" />
      </svg>;
  }
  return <svg {...common} data-id="element-80" data-mp="1qzyq19xpoww0">
      <path d="M14 3v11.5a3.5 3.5 0 1 1-3.5-3.5" data-id="element-81" data-mp="1r1jmj53l6pwi" />
      <path d="M14 3c.4 2.6 2.2 4.4 5 4.7" data-id="element-82" data-mp="1r2uqp60y1zo5" />
    </svg>;
}